import jkhubexpressLogo from '../assets/img/jkhubexpress-logo.PNG';
import motumLogo from '../assets/img/motum-logo.png';

 const logo_map = {
  'motumbrasil.com': motumLogo,
  'hubjk.com': jkhubexpressLogo,
};

export default logo_map;